export const getUsers = async (resource) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/user`)
        .then(
            (response) => {
                result = response.body.user
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const getUser = async (resource, id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/user/${id}`)
        .then(
            (response) => {
                result = response.body.user
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const modifyUser = async (resource, id, data) => {
    let result
    await resource
        .put(`api/${localStorage.getItem('perfil')}/user/${id}`, data)
        .then(
            (response) => {
                result = response.body.user
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const changePassword = async (resource, id,data) => {
    let result
    await resource
      .put(`api/${localStorage.getItem('perfil')}/user/new_passwd/` + id,data)
      .then(
        (response) => {
          result=response.body.user
        },
        (response) => {
          console.log(response);
        }
      );
    return result;
  }